// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1_oI1","inputWrap":"styles_inputWrap__1N28d","input":"styles_input__18KIB"};